import React from 'react';
import PropTypes from 'prop-types';

import { Multiselect } from 'spicecomponents';

const MultipleYears = (props) => {
  const onChange = (selectedOptions) => {
    if (selectedOptions.length > 0) {
      props.onChange(selectedOptions.map((option) => option.value));
    } else {
      props.onChange(null);
    }
  };

  return (
    <Multiselect options={getOptions(props.controlList)} value={getValue(props.cdf)} onChange={onChange} />
  );
};

const getOptions = (controlList) => (
  controlList.Options.map((year) => ({
    value: year,
  }))
);

const getValue = (cdf) => (
  cdf.YearsToShow || []
);

MultipleYears.propTypes = {
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  onChange: PropTypes.func,
};

export default MultipleYears;



// WEBPACK FOOTER //
// ./app/components/FormControls/YearsToShow/MultipleYears.js